import React, { useRef, useState } from "react";
import axios from "axios";
import { Form, Button, Col, Row } from "react-bootstrap";
import alertify from "alertifyjs";
import { API_URL } from "../constants.js";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../_metronic/_partials/controls";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function SamplesArrived() {
  const { t } = useTranslation();
  const sample_id = useRef();
  const phone_no = useRef();
  const [disabled, setDisabled] = useState(false);
  const [sampleIdError, setSampleIdError] = useState("");
  const [validatingSampleId, setValidatingSampleId] = useState(false);

  const validateSampleId = (sampleIdValue) => {
    const trimmed = (sampleIdValue || "").trim();
    if (!trimmed) {
      setSampleIdError(t("Sample ID is not Valid"));
      return Promise.resolve(false);
    }

    setValidatingSampleId(true);
    return axios
      .post(API_URL + "patient/validate-sample-id-for-arrival", {
        sample_id: trimmed,
      })
      .then((response) => {
        setValidatingSampleId(false);
        if (response.data.status) {
          setSampleIdError("");
          return true;
        }
        const message =
          response.data.message || t("Sample ID is not Valid");
        setSampleIdError(message);
        alertify.error(message);
        return false;
      })
      .catch((error) => {
        setValidatingSampleId(false);
        const message =
          error.response?.data?.message || t("Sample ID is not Valid");
        setSampleIdError(message);
        alertify.error(message);
        return false;
      });
  };

  const handleSampleIdBlur = () => {
    if (sample_id.current?.value?.trim()) {
      validateSampleId(sample_id.current.value);
    } else {
      setSampleIdError("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const sampleOk = await validateSampleId(sample_id.current.value);
    if (!sampleOk) {
      return;
    }

    setDisabled(true);

    axios
      .post(API_URL + "patient/samples-arrived", {
        sample_id: sample_id.current.value.trim(),
        phone_no: phone_no.current.value,
      })
      .then((response) => {
        setDisabled(false);
        if (response.data.status) {
          alertify.success(response.data.message);
          sample_id.current.value = "";
          phone_no.current.value = "+44";
          setSampleIdError("");
        } else {
          const message =
            response.data.message || t("Sample ID is not Valid");
          if (
            message.toLowerCase().includes("sample id") ||
            message.includes("SIAE")
          ) {
            setSampleIdError(message);
          }
          alertify.error(message);
        }
      })
      .catch((error) => {
        setDisabled(false);
        if (error.message === "Request failed with status code 401") {
          return;
        }
        const message =
          error.response?.data?.message ||
          "Unable to save sample arrived record";
        if (
          message.toLowerCase().includes("sample id") ||
          message.includes("SIAE")
        ) {
          setSampleIdError(message);
        }
        alertify.error(message);
      });
  };

  return (
    <Row>
      <Col md={12}>
        <Card>
          <CardHeader title={t("Sample Arrived")} />
          <CardBody>
            <p className="text-muted small mb-4">
              {t(
                "Record a sample that has arrived at the lab. The patient will receive an SMS with the registration link to complete their details online."
              )}
            </p>
            <p className="text-muted small mb-4">
              {t(
                "Sample ID must start with a valid prefix (LHC, ABP, HHUK, PPP, REP) followed by digits, or with a test sort code (3 characters) that exists in the system, followed by digits."
              )}
            </p>
            <Form onSubmit={handleSubmit}>
              <Form.Row>
                <Form.Group as={Col} md={4}>
                  <Form.Label>{t("Sample ID")} *</Form.Label>
                  <Form.Control
                    ref={sample_id}
                    placeholder={t("Sample ID")}
                    required
                    onBlur={handleSampleIdBlur}
                    isInvalid={!!sampleIdError}
                  />
                  <Form.Control.Feedback type="invalid">
                    {sampleIdError}
                  </Form.Control.Feedback>
                  {validatingSampleId ? (
                    <Form.Text className="text-muted">
                      {t("Validating sample ID…")}
                    </Form.Text>
                  ) : null}
                </Form.Group>
                <Form.Group as={Col} md={4}>
                  <Form.Label>{t("Phone Number")} *</Form.Label>
                  <Form.Control
                    ref={phone_no}
                    placeholder={t("Phone Number")}
                    defaultValue="+44"
                    required
                  />
                </Form.Group>
              </Form.Row>
              <div className="d-flex justify-content-between align-items-center mt-3">
                <Link to="/dashboard" className="btn btn-light btn-sm">
                  {t("Back to Dashboard")}
                </Link>
                <Button
                  variant="primary"
                  type="submit"
                  disabled={disabled || validatingSampleId}
                >
                  {t("Save")}
                  <span
                    dangerouslySetInnerHTML={{
                      __html:
                        disabled || validatingSampleId
                          ? `<i class='fas fa-spinner fa-spin'></i>`
                          : ``,
                    }}
                  />
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}
